import styled from "styled-components";

export const ModalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 80px;
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
  border-radius: 6px 6px 0 0;
`;
